var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12",staticStyle:{"height":"100%"}},[_c('leave-count'),_vm._v(" "),_c('h4',{staticStyle:{"font-weight":"600","padding-bottom":"5px"}},[_vm._v("Leave History")]),_vm._v(" "),_c('div',{staticStyle:{"border-bottom":"1.5px dashed rgb(221, 221, 221)"}}),_vm._v(" "),_c('leave-history')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bcf0909","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ESSProfile/LeaveManagement/LeaveReport.vue
// module id = null
// module chunks = 